/**
 * The product mark: an agent core wired to the nodes it orchestrates, inside a speech
 * surface. Kept in sync with `public/favicon.svg` — change both together.
 */
export default function Logo({ size = 40, className = "" }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 64 64"
      role="img"
      aria-label="سامانه ایجنت‌ها"
    >
      <defs>
        <linearGradient id="logo-bg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#6366f1" />
          <stop offset="55%" stopColor="#7c3aed" />
          <stop offset="100%" stopColor="#0ea5a4" />
        </linearGradient>
      </defs>

      <rect width="64" height="64" rx="16" fill="url(#logo-bg)" />

      <path
        d="M18 19h28a5 5 0 0 1 5 5v15a5 5 0 0 1-5 5H31l-8.5 7.2A1 1 0 0 1 21 50.4V44h-3a5 5 0 0 1-5-5V24a5 5 0 0 1 5-5z"
        fill="#ffffff"
        fillOpacity="0.96"
      />

      <circle cx="32" cy="31.5" r="5.2" fill="#5b21b6" />
      <circle cx="21.5" cy="26" r="2.6" fill="#7c3aed" />
      <circle cx="42.5" cy="26" r="2.6" fill="#7c3aed" />
      <circle cx="21.5" cy="37" r="2.6" fill="#0ea5a4" />
      <circle cx="42.5" cy="37" r="2.6" fill="#0ea5a4" />
      <g stroke="#7c3aed" strokeWidth="1.7" strokeLinecap="round" opacity="0.75">
        <path d="M27.6 28.6 23.6 26.8" />
        <path d="M36.4 28.6 40.4 26.8" />
      </g>
      <g stroke="#0ea5a4" strokeWidth="1.7" strokeLinecap="round" opacity="0.75">
        <path d="M27.6 34.4 23.6 36.2" />
        <path d="M36.4 34.4 40.4 36.2" />
      </g>
    </svg>
  );
}
